import { jsxs as _jsxs, jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
import { LeadServiceAPI } from '../../api/LeadServiceAPI.js';
import { handleAspects } from '../../hooks/useAspects/handleAspects.js';
import { useAspects } from '../../hooks/useAspects/useAspects.js';
import { useForm } from '../../hooks/useForm.js';
import { ApplicationFormLayout } from '../../ui-kit/ApplicationFormLayout/ApplicationFormLayout.js';
import { useResponseTypeDialog } from '../../ui-kit/ResponseTypeDialog/useResponseTypeDialog.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { style } from '../../utils/style.js';
import { objectValidator } from '../../validation/objectValidator.js';
import { isValidationSuccess } from '../../validation/validator.js';
import { getField } from './getField.js';
import { getFormatData } from './getFormatData.js';
import { getInitialFormState } from './getInitialFormState.js';
import { getObjectValidator } from './getObjectValidator.js';
import { renderAgreementSubmit } from './renderAgreementSubmit.js';
import { renderContacts } from './renderContacts.js';
const API = LeadServiceAPI();
export const ApplicationForm = JSX(
// eslint-disable-next-line max-lines-per-function
({ className, title, typeForm = '', sections = [], button, link, endpoint, additionalParams, isContacts, data, ...rest }) => {
    const inputs = (sections?.flatMap((_) => _?.inputs) || []);
    const initialFormState = getInitialFormState(inputs, typeForm);
    const [responseType, setResponseType] = useState('');
    const handleSubmit = useCallback(async (formData, ev) => {
        const inputsFiltered = getFilteredInputs(inputs, formData);
        const feedbackValidator = objectValidator(getObjectValidator(inputsFiltered));
        if (!isValidationSuccess(feedbackValidator(formData))) {
            return 'Fail';
        }
        const formatData = getFormatData({ ...formData, ...additionalParams });
        const status = (await API.send(formatData, endpoint === 'lead')) ? 'OK' : 'Fail';
        setResponseType(status);
        if (status) {
            const responseTypeDialog = useResponseTypeDialog({ responseType: status, typeForm });
            responseTypeDialog.open();
        }
        if (status === 'OK' && data) {
            const aspects = useAspects();
            handleAspects({ aspectsAttributes: data, aspects, ev });
        }
        return status;
    }, []);
    const [, { field, onSubmit, reset }] = useForm(initialFormState, { onSubmit: handleSubmit });
    const fieldName = getConsentDataProcessing(inputs)?.name;
    useEffect(() => {
        if (responseType === 'OK') {
            setResponseType('');
            reset();
        }
    }, [responseType]);
    return (_jsxs(ApplicationFormLayout, { className: style('container space-y-m', className), title: title, ...rest, children: [_jsxs("form", { onSubmit: onSubmit, children: [sections.map((_, i) => (_jsxs("div", { className: style(inputColumnStyles(_.columns), 'grid gap-x-m'), children: [renderTitle(_.title), (_?.inputs || [])?.map(getField(field, typeForm))] }, `section-${i}`))), renderAgreementSubmit(fieldName ? field('consentDataProcessing') : undefined, link, button)] }), isContacts ? renderContacts() : null] }));
});
const renderTitle = (title) => title ? (_jsx("div", { className: "@xl:text-center @xl:col-span-2 mb-m", children: _jsx(Text, { size: "text-h6", children: title }) })) : null;
const inputColumnStyles = (column) => column === 2 ? '@xl:grid-cols-2' : '';
const getConsentDataProcessing = (inputs) => inputs?.find((_) => _?.name === 'consentDataProcessing');
const getFilteredInputs = (inputs, data) => inputs
    .filter((_) => _)
    .filter((input) => !input?.condition ||
    input?.condition.values.find((_) => {
        const dataValue = data?.[input?.condition?.name ?? ''];
        return input.name === 'secondaryPhone'
            ? Boolean(data.secondaryPhone)
            : _ === (dataValue?.key ?? dataValue);
    }));
//# sourceMappingURL=ApplicationForm.js.map